export { default } from "~/components/wishlist/WishlistGallery";
export { loader } from "~/components/search/SearchTitleAndResult";

export const eager = true;
export const sync = true;
